module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_7016.d898e329.png";